import type { ConversationMessage } from '@atlassian/unified-help-common/src/types';

export const getTotalHelpDesks = (message: ConversationMessage): number => {
    return message?.appendices?.filter((appendix) => appendix.type === 'helpDesk')?.length ?? 0;
};
